import { Injectable, effect, signal } from '@angular/core';

import { DensityEnum, ThemesEnum } from '../../../enums/themes.enum';
import { GoogleAnalyticsService } from '../ga/google-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  themeSignal = signal<ThemesEnum>(ThemesEnum.LIGHT);
  densitySignal = signal<DensityEnum>(DensityEnum.DEFAULT);

  constructor(private gaService: GoogleAnalyticsService) {
    const theme = localStorage.getItem('phoenixTheme') as ThemesEnum | null;
    const density = localStorage.getItem(
      'phoenixDensity'
    ) as DensityEnum | null;

    if (theme) {
      this.themeSignal.set(theme);
    }

    if (density) {
      this.densitySignal.set(density);
    }

    effect(() => {
      document.body.setAttribute('data-theme', this.themeSignal());

      // Remove existing density classes
      const densityEnumValues = Object.values(DensityEnum);
      densityEnumValues.forEach(densityValue => {
        document.body.classList.remove(`density-${densityValue}`);
      });

      // Add the current density class
      document.body.classList.add(`density-${this.densitySignal()}`);

      // Tracking theme and density
      this.trackTheme(this.themeSignal());
      this.trackDensity(this.densitySignal());
    });
  }

  setTheme(theme: ThemesEnum) {
    localStorage.setItem('phoenixTheme', theme);
    this.themeSignal.set(theme);
  }

  setDensity(density: DensityEnum) {
    localStorage.setItem('phoenixDensity', density);
    this.densitySignal.set(density);
  }

  private trackTheme(theme: ThemesEnum) {
    this.gaService.eventEmitter('q6_tracking_theme', {
      theme: theme,
    });
  }

  private trackDensity(density: DensityEnum) {
    this.gaService.eventEmitter('q6_tracking_density', {
      density: density,
    });
  }
}
